import { useTheme } from '@mui/material/styles'

import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'

const AppFooter = () => {
  const theme = useTheme()
  //@ts-ignore
  const custom = theme.custom

  return (
    <footer
      style={{
        // background: '#565a5c',
        borderTop: '2px solid #dcdcdc',
        width: '100%',
      }}
    >
      <Container maxWidth={false} sx={{ marginTop: '15px' }}>
        <Grid container spacing={3}>
          <Grid item sm={2}>
            <img src={custom?.logo} width="83" height="auto" alt="MeetParker" />
          </Grid>
          <Grid item xs={12} sm={10}>
            <Box
              margin="20px 0px"
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Link
                href={`tel:${custom?.contactNumber}`}
                underline="none"
                marginBottom="0px !important"
              >
                <Typography fontSize={14} letterSpacing={2} color="primary">
                  {custom?.contactNumber}
                </Typography>
              </Link>
              <Typography fontSize={14} margin="0px 10px" color="primary">
                |
              </Typography>
              <Link
                href={`mailto:${custom?.email}`}
                underline="none"
                marginBottom="0px !important"
              >
                <Typography fontSize={14} letterSpacing={2} color="primary">
                  {custom?.email}
                </Typography>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth={false} style={{ backgroundColor: '#dcdcdc' }}>
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            sm={6}
            padding="10px 0px"
            display="flex"
            alignItems="center"
          >
            <Typography color="primary">
              ©&nbsp;{custom?.customization?.companyName || "Meet Parker"} {new Date().getFullYear()}
            </Typography>
            <Typography fontSize={14} margin="0px 5px">
              |
            </Typography>
            <Link
              href={custom?.links?.privacyPolicyURL}
              target="_blank"
              underline="none"
              marginBottom="0px !important"
            >
              <Typography color="#737373" fontSize={12} letterSpacing={0}>
                Privacy Policy
              </Typography>
            </Link>
            <Typography fontSize={14} margin="0px 5px">
              |
            </Typography>
            <Link
              href={custom?.links?.termsAndConditionsURL}
              target="_blank"
              underline="none"
              marginBottom="0px !important"
            >
              <Typography color="#737373" fontSize={12} letterSpacing={0}>
                Terms & Conditions
              </Typography>
            </Link>
          </Grid>
          {/* <Grid item xs={12} sm={6} padding="10px 0px">
            <Typography fontSize={12} color="#737373" textAlign="right">
              Meet Parker a Registered Trademark of Meet Parker Ltd, a company
              registered in England and Wales. Company registration number:
              13066663
            </Typography>
          </Grid> */}
        </Grid>
      </Container>
    </footer>
  )
}

export default AppFooter
